<template>
    <div class="o2concentration">
        <table>
            <tr>
                <td class="left">
                    <label>O<sub>2</sub> {{type}}</label>
                </td>

                <td class="result">
                  <label >{{concentration}} {{units}}</label>
                </td>
            </tr>
        </table>
    </div>
</template>

<script>
export default {
  /* eslint-disable */
name: 'o2concentration',
props: {
    unit: String,
    triggerprop: Number,
    obj: Object
},
data: () => ({
    concentration: 0,
    units: "\u03BCmol/L",
    unitso2: [
            "\u03BCmol/L",
            "mm Hg",
            "mBar",
            "%",
            "ppm (vol/vol)",
            "ppm (mg/L)"
        ],
        type: "Concentration:"
}),
methods: {
  calculate () {
    var temp
    var pressure
    var sal
    var gasconc
    var conc

      //converts to celcius
    if (this.obj.tempType === "Kelvin") {
      temp = Number(this.obj.temp) - 273.15
    } else {
      temp = Number(this.obj.temp)
    }

    pressure = Number(this.obj.pressure)
    sal = Number(this.obj.salinity)
    gasconc = Number(this.obj.gasConcentration)

    switch(this.unit) {
      case "\u03BCmol/L":
        conc = this.UMolL(temp, sal, pressure, gasconc)
        this.units = "\u03BCmol/L"
        this.type = "Concentration:"
        break;
      case "mm Hg":
        conc = this.mmHg(temp, sal, pressure, gasconc)
        this.units = "mm Hg"
        this.type = "Partial Pressure:"
        break;
      case "%":
        conc = this.Saturation(temp, sal, pressure, gasconc)
        this.units = "%"
        this.type = "Concentration:"
        break;
      case "mBar":
        conc = this.mBar(temp, sal, pressure, gasconc)
        this.units = "mBar"
        this.type = "Partial Pressure:"
        break;
      case "ppm (vol/vol)":
        conc = this.ppm(temp, sal, pressure, gasconc)
        this.units = "ppm (vol/vol)"
        this.type = "Concentration:"
        break;
      case "ppm (mg/L)":
        conc = this.ppmmgL(temp, sal, pressure, gasconc)
        this.units = "ppm (mg/L)"
        this.type = "Concentration:"
        break;
      default:
          console.log(this.unit)
          this.units = "N/A"
          conc = 0;
          this.type = ""
    }
    this.concentration = conc.toPrecision(6)
  },
  K(temp, sal){
    var T0 = 273.15
    var p_sat = Math.exp((52.57 - (6690.9 / (temp+T0))) - 4.681 * Math.log(temp+T0))
    var ptable = 0.20946 * (1013.25 - p_sat)
    var temp = Math.exp(5.80818 + 3.20684 * Math.log((298.15 - temp) / (T0 + temp))
    + 4.1189 * Math.pow(Math.log((298.15 - temp) / (T0 + temp)), 2) + 4.93845 *
    Math.pow(Math.log((298.15 - temp) / (T0 + temp)), 3) + 1.01567 * Math.pow(Math.log((298.15
    - temp) / (T0 + temp)), 4) + 1.41575 * Math.pow(Math.log((298.15 - temp) / (T0 + temp)), 5)
    + sal  * (-0.00701211 + (-0.00725958) * Math.log((298.15 - temp) / (T0 + temp)) +
    (-0.00793334) * Math.pow(Math.log((298.15 - temp) / (T0 + temp)), 2) + (-0.00554491)
    * Math.pow(Math.log((298.15 - temp) / (T0 + temp)), 3)) + (-0.000000132412) *
    Math.pow(sal, 2)) * (999.842594 + 0.06793952 * temp - 0.00909529 * Math.pow(temp, 2) +
    0.0001001685 * Math.pow(temp, 3) - 0.000001120083 * Math.pow(temp, 4) + 0.000000006536336 *
    Math.pow(temp, 5) + (0.824493 - 0.0040899 * temp + 0.000076438 * Math.pow(temp, 2) -
    0.00000082467 * Math.pow(temp, 3) + 0.0000000053875 * Math.pow(temp, 4)) * sal +
    (-0.00572466 + 0.00010227 * temp - 0.0000016546 * Math.pow(temp, 2)) * Math.pow(sal, (3.0 /
    2.0)) + 0.00048314 * Math.pow(sal, 2)) / 1000;
    return temp/ptable
  },
  UMolL(temp, sal, pressure, gasconc){
    let result
    switch(this.obj.unitIn){
      case "\u03BCmol/L":
        return gasconc
      case "ppm (mg/L)":
        return gasconc*1000/(31.998)
      case "mm Hg":
        var T0 = 273.15
        var p_sat = Math.exp((52.57 - (6690.9 / (temp+T0))) - 4.681 * Math.log(temp+T0))
        var t = this.K(temp, sal)
        return t * (gasconc / 0.750061683)
      case "%":
        var T0 = 273.15
        var p_sat = Math.exp((52.57 - (6690.9 / (temp+T0))) - 4.681 * Math.log(temp+T0))
        var partpres = (pressure - p_sat) * gasconc / 100
        return this.K(temp,sal) * partpres
      case "mBar":
        var T0 = 273.15
        var p_sat = Math.exp((52.57 - (6690.9 / (temp+T0))) - 4.681 * Math.log(temp+T0))
        var t = this.K(temp, sal)
        return t * gasconc
      case "ppm (vol/vol)":
        var T0 = 273.15
        var p_sat = Math.exp((52.57 - (6690.9 / (temp+T0))) - 4.681 * Math.log(temp+T0))
        var partpres = (pressure - p_sat) * gasconc / 1000000
        return this.K(temp,sal) * partpres
    }
    return result
  },
  mmHg(temp, sal, pressure, gasconc){
    switch(this.obj.unitIn){
      case "\u03BCmol/L":
        //var T0 = 273.15
        //var p_sat = Math.exp((52.57 - (6690.9 / (temp+T0))) - 4.681 * Math.log(temp+T0))
        return gasconc/this.K(temp, sal)*0.750061683
      case "ppm (mg/L)":
        //var T0 = 273.15
        //var p_sat = Math.exp((52.57 - (6690.9 / (temp+T0))) - 4.681 * Math.log(temp+T0))
        var conc = gasconc*1000/(31.998)
        return conc/this.K(temp,sal)*0.750061683
      case "mm Hg":
        return gasconc
      case "%":
        var T0 = 273.15
        var p_sat = Math.exp((52.57 - (6690.9 / (temp+T0))) - 4.681 * Math.log(temp+T0))
        var partpres = (pressure - p_sat) * gasconc / 100
        return partpres*0.750061683
      case "mBar":
        return gasconc*0.750061683
      case "ppm (vol/vol)":
        var T0 = 273.15
        var p_sat = Math.exp((52.57 - (6690.9 / (temp+T0))) - 4.681 * Math.log(temp+T0))
        var partpres = (pressure - p_sat) * gasconc / 1000000
        return partpres*0.750061683
    }
  },
  Saturation(temp, sal, pressure, gasconc){
    switch(this.obj.unitIn){
      case "\u03BCmol/L":
        var T0 = 273.15
        var p_sat = Math.exp((52.57 - (6690.9 / (temp+T0))) - 4.681 * Math.log(temp+T0))
        return (gasconc/this.K(temp, sal))/(pressure-p_sat)*100
      case "ppm (mg/L)":
        var T0 = 273.15
        var p_sat = Math.exp((52.57 - (6690.9 / (temp+T0))) - 4.681 * Math.log(temp+T0))
        var conc = gasconc*1000/(31.998)
        return (conc/this.K(temp, sal, pressure, gasconc))/(pressure-p_sat)*100
      case "mm Hg":
        var T0 = 273.15
        var p_sat = Math.exp((52.57 - (6690.9 / (temp+T0))) - 4.681 * Math.log(temp+T0))
        return (gasconc/0.750061683)/(pressure-p_sat)*100
      case "%":
        return gasconc
      case "mBar":
        var T0 = 273.15
        var p_sat = Math.exp((52.57 - (6690.9 / (temp+T0))) - 4.681 * Math.log(temp+T0))
      /*return (gasconc/0.750061683)/(pressure-p_sat)*1000000*/
        return (gasconc ) * 100 / (pressure - p_sat)
      case "ppm (vol/vol)":
        return gasconc/10000
    }
  },
  mBar(temp, sal, pressure, gasconc){
    switch(this.obj.unitIn){
      case "\u03BCmol/L":
        var T0 = 273.15
        var p_sat = Math.exp((52.57 - (6690.9 / (temp+T0))) - 4.681 * Math.log(temp+T0))
        return gasconc/this.K(temp, sal)
      case "ppm (mg/L)":
        //var T0 = 273.15
        //var p_sat = Math.exp((52.57 - (6690.9 / (temp+T0))) - 4.681 * Math.log(temp+T0))
        var conc = gasconc*1000/(31.998)
        return conc/this.K(temp, sal)
      case "mm Hg":
        return gasconc/0.750061683
      case "%":
        var T0 = 273.15
        var p_sat = Math.exp((52.57 - (6690.9 / (temp+T0))) - 4.681 * Math.log(temp+T0))
        var partpres = (pressure - p_sat) * gasconc / 100
        return partpres
      case "mBar":
        return gasconc
      case "ppm (vol/vol)":
        var T0 = 273.15
        var p_sat = Math.exp((52.57 - (6690.9 / (temp+T0))) - 4.681 * Math.log(temp+T0))
        var partpres = (pressure - p_sat) * gasconc / 1000000
        return partpres
    }
  },
  ppm(temp, sal, pressure, gasconc){
    switch(this.obj.unitIn){
      case "\u03BCmol/L":
        var T0 = 273.15
        var p_sat = Math.exp((52.57 - (6690.9 / (temp+T0))) - 4.681 * Math.log(temp+T0))
        var partpres = gasconc/this.K(temp,sal)
        return partpres*1000000/(pressure-p_sat)
      case "ppm (mg/L)":
        var T0 = 273.15
        var p_sat = Math.exp((52.57 - (6690.9 / (temp+T0))) - 4.681 * Math.log(temp+T0))
        var conc = gasconc*1000/(31.998)
        var partpres = conc / this.K(temp, sal)
        return partpres * 1000000 / (pressure - p_sat)
      case "mm Hg":
        var T0 = 273.15
        var p_sat = Math.exp((52.57 - (6690.9 / (temp+T0))) - 4.681 * Math.log(temp+T0))
        return (gasconc/0.750061683)/(pressure-p_sat)*1000000
      case "%":
        return gasconc*10000
      case "mBar":
        var T0 = 273.15
        var p_sat = Math.exp((52.57 - (6690.9 / (temp+T0))) - 4.681 * Math.log(temp+T0))
        var ptable = 0.20946 * (1013.25 - p_sat)
        return (gasconc)/(pressure-p_sat)*1000000
      case "ppm (vol/vol)":
        return gasconc
    }
  },
  ppmmgL(temp, sal, pressure, gasconc){
    switch(this.obj.unitIn){
      case "\u03BCmol/L":
        return gasconc*31.998/1000
      case "ppm (mg/L)":
        return gasconc
      case "mm Hg":
        var T0 = 273.15
        var p_sat = Math.exp((52.57 - (6690.9 / (temp+T0))) - 4.681 * Math.log(temp+T0))
        var conc = this.K(temp,sal)*(gasconc/0.750061683)
        return conc*31.998/1000
      case "%":
        var T0 = 273.15
        var p_sat = Math.exp((52.57 - (6690.9 / (temp+T0))) - 4.681 * Math.log(temp+T0))
        var partpres = (pressure - p_sat) * gasconc / 100
        var conc = this.K(temp,sal)*partpres
        return conc*31.998/1000
      case "mBar":
        var T0 = 273.15
        var p_sat = Math.exp((52.57 - (6690.9 / (temp+T0))) - 4.681 * Math.log(temp+T0))
        var conc = this.K(temp,sal)*gasconc
        return conc*31.998/1000
      case "ppm (vol/vol)":
        var T0 = 273.15
        var p_sat = Math.exp((52.57 - (6690.9 / (temp+T0))) - 4.681 * Math.log(temp+T0))
        var partpres = (pressure - p_sat) * gasconc / 1000000
        var conc = this.K(temp,sal)*partpres
        return conc*31.998/1000
    }
  }

},
mounted() {
    this.calculate()
},
watch: {
    triggerprop: function(newval, oldval) {
        this.calculate()
    }
}
}
</script>
